import React from "react";
import PoliticaInversion from "../politica-inversion";
import styles from "./boton-expandir.module.css";

const BotonExpandir = ({ proyecciones, expandido , expandirTabla, mostrarPoliticaInversion }) => {
    return (
        <div className={styles.grid_botones}>
            <div className={styles.gb_space} />
            <div
                className={styles.gb_boton_tabla}
                onClick={proyecciones.length > 0
                    ? () => expandirTabla() : undefined}>
                        {proyecciones.length > 0
                            ? <React.Fragment>
                                <span className={styles.boton_tabla_span}>
                                    {!expandido ? 'Expandir tabla' : 'Reducir tabla'}
                                </span>
                                <div className={`${styles.boton_expandir} ${!expandido ? null : styles.boton_reducir}`} />
                            </React.Fragment>
                            : null
                        }
            </div>
            {mostrarPoliticaInversion !== undefined && mostrarPoliticaInversion
                ? <div className={styles.gb_politica}>
                    <PoliticaInversion />
                </div>
                : null
            }
        </div>
    )
}

export default BotonExpandir;